// extracted by mini-css-extract-plugin
export default {"body":"NotFoundPage_body__IA-Mv","back":"NotFoundPage_back__kO-3o"};